import { WalletType } from "cosmes/wallet";
import { useWallet } from "providers/WalletProvider";
import { useEffect, useState } from "react";
import { useFetcher, useSearchParams } from "react-router-dom";
import { formatAddress, isMobileDevice } from "utils/Functions";
import { queryDelegation } from "utils/RpcHelper";
import { SUPPORTED_WALLETS, WalletSupport } from "utils/WalletSupport";

export function ConnectPage() {
    const { id, address, disconnect } = useWallet()
    const [searchParams, setSearchParams] = useSearchParams();

    return <div className="w-100 p-2 px-4 px-4">
        <h4>Connect Wallet</h4>

        <div className="preview-list">
            {
                !address && SUPPORTED_WALLETS.map(
                    wallet => <WalletItem wallet={wallet} />
                )
            }

            {
                address &&
                <div className="preview-item border-bottom">
                    <div className="preview-thumbnail">
                        <div className="preview-icon bg-success">
                            <i className="mdi mdi-wallet"></i>
                        </div>
                    </div>
                    <div className="preview-item-content d-flex flex-grow">
                        <div className="flex-grow">
                            <h6 className="preview-subject">{formatAddress(address)}</h6>
                            <p className="text-muted mb-0">{id}</p>
                        </div>
                        <button onClick={() => disconnect()} type="button" className="btn btn-danger ">Disconnect</button>
                    </div>
                </div>
            }
        </div>
    </div>
}


function WalletItem(prop: { wallet: WalletSupport }) {
    const { connect } = useWallet()
    const [isInstalled, setIsInstalled] = useState(false)


    const loadWalletInfo = async () => {
        const isInstalled = await prop.wallet.isInstalled();
        setIsInstalled(isInstalled)
    }

    useEffect(() => {
        setInterval(() => loadWalletInfo(), 1000)
    }, [])

    return <>
        {
            isInstalled && <div className="preview-item border-bottom">
                <div className="preview-thumbnail">
                    <div className="preview-icon bg-success">
                        <i className="mdi mdi-wallet"></i>
                    </div>
                </div>
                <div className="preview-item-content d-flex flex-grow">
                    <div className="flex-grow">
                        <h6 className="preview-subject">{prop.wallet.name}</h6>
                        <p className="text-muted mb-0">{prop.wallet.type == WalletType.EXTENSION ? "Extension" : "Mobile"}</p>
                    </div>
                    <button onClick={() => connect(prop.wallet)} type="button" className="btn btn-primary">Connect</button>

                </div>
            </div>
        }
    </>
}